import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/useI18n';
import { useSeo } from './useSeo';

export function NotFoundPage() {
  const { t } = useI18n();
  useSeo('seo.notFound.title', 'seo.notFound.description');

  return (
    <main>
      <section className="page-hero">
        <p className="eyebrow">404</p>
        <h1>{t('notFound.title')}</h1>
        <p>{t('notFound.text')}</p>
        <Link className="button primary" to="/">
          {t('notFound.home')}
        </Link>
      </section>
    </main>
  );
}
